import React from 'react';
import * as Icons from 'lucide-react';
import { Reveal } from '../Reveal';
import { coach } from '../../config/coach';

const ApproachSection = () => {
  const { kicker, heading, sub, items } = coach.approach;

  return (
    <section id="results" className="relative bg-black py-24 sm:py-32" data-testid="results-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="text-center max-w-xl mx-auto mb-14 sm:mb-16">
          <Reveal><span className="kicker justify-center before:hidden">{kicker}</span></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display font-bold uppercase text-ivory tracking-tight leading-[0.9] text-5xl sm:text-6xl lg:text-7xl mt-4">
              {heading}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-5 text-white/55 text-sm sm:text-base">{sub}</p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-white/10 border border-white/10 rounded-2xl overflow-hidden">
          {items.map((item, i) => {
            const Icon = Icons[item.icon] || Icons.Target;
            return (
              <Reveal key={i} delay={i * 0.08} className="h-full">
                <div
                  className="group h-full bg-[#0a0a0a] hover:bg-white/[0.04] transition-colors duration-500 p-8 sm:p-9"
                  data-testid={`approach-card-${i}`}
                >
                  <div className="flex items-center gap-4 mb-6">
                    <span className="font-display text-gold-soft/70 text-sm tracking-[0.25em]">0{i + 1}</span>
                    <span className="flex-1 h-px bg-white/10" />
                    <div className="w-11 h-11 rounded-full border border-white/15 flex items-center justify-center group-hover:border-gold-soft/50 transition-colors duration-500">
                      <Icon className="w-5 h-5 text-gold-soft" strokeWidth={1.6} />
                    </div>
                  </div>
                  <h3 className="font-display uppercase tracking-wide text-ivory text-2xl mb-3">{item.title}</h3>
                  <p className="text-white/55 text-sm sm:text-base leading-relaxed">{item.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ApproachSection;
